var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import BusinessExternalService from '@dashboard/junk-drawer/clients/business-external-service';
import { Empty } from '@square/dashboard-protos/models/squareup/common/messages';
import { GetMerchantCategoriesResponse } from '@square/dashboard-protos/models/squareup/onboarding/business/common';
import { BusinessCategory } from '@square/dashboard-protos/models/squareup/onboard/business/categories';
import { BusinessSubcategory } from '@square/dashboard-protos/models/squareup/onboard/business/subcategories';
import * as Sentry from '@sentry/browser';
let MerchantCategories = (_class = class MerchantCategories extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "categories", _descriptor, this);
    _defineProperty(this, "setupPromise", void 0);
  }
  async getAndSetMerchantCategories() {
    try {
      this.categories = await BusinessExternalService.getMerchantCategories(Empty);
    } catch (e) {
      if (e.responseStatus === 404) {
        this.categories = GetMerchantCategoriesResponse.create({
          category: BusinessCategory.BUSINESS_CATEGORY_UNKNOWN,
          subcategory: BusinessSubcategory.BUSINESS_SUBCATEGORY_UNKNOWN
        });
      } else {
        Sentry.captureException(`Error loading merchant business categories: ${e}`);
      }
    }
    return this.categories;
  }
  async setup() {
    if (!this.setupPromise) {
      this.setupPromise = this.getAndSetMerchantCategories();
      const categories = await this.setupPromise;
      return categories;
    }
    return this.setupPromise;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "categories", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
})), _class);
export { MerchantCategories as default };